(function(){
  "use strict";
  var CHIP_SEL=".mc-filter-bar__chip";
  var DROPDOWN_SEL=".mc-filter-dropdown";
  var OPEN_CLASS="mc-filter-dropdown--open";
  var MOB_BP=768;
  var CHECK_SVG='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function isMobile(){ return window.innerWidth < MOB_BP; }

  function init(){
    var bar=document.querySelector(".mc-filter-bar");
    if(!bar) return;
    bindEvents(bar);
  }

  function bindEvents(root){
    root.querySelectorAll(CHIP_SEL).forEach(function(chip){
      if(!chip._zfBound){chip.addEventListener("click",handleChipClick);chip._zfBound=true;}
    });
    root.querySelectorAll(".mc-filter-dropdown__search-input").forEach(function(inp){
      if(!inp._zfBound){inp.addEventListener("input",handleSearch);inp._zfBound=true;}
    });
    root.querySelectorAll(".mc-filter-dropdown__link").forEach(function(lnk){
      if(!lnk._zfBound){lnk.addEventListener("click",handleFilterClick);lnk._zfBound=true;}
    });
    root.querySelectorAll(".mc-filter-dropdown__price-apply").forEach(function(btn){
      if(!btn._zfBound){btn.addEventListener("click",handlePriceApply);btn._zfBound=true;}
    });
    root.querySelectorAll(".mc-filter-dropdown__show-all").forEach(function(btn){
      if(!btn._zfBound){btn.addEventListener("click",handleShowAll);btn._zfBound=true;}
    });
  }

  /* ── Progressive Disclosure: "Alle Modelle anzeigen" ── */
  function handleShowAll(e){
    e.preventDefault();e.stopPropagation();
    var dd=e.target.closest(DROPDOWN_SEL);
    if(!dd) return;
    lazyLoadModels(dd);
    var search=dd.querySelector(".mc-filter-dropdown__search--hidden");
    if(search) search.classList.remove("mc-filter-dropdown__search--hidden");
    e.target.style.display="none";
    dd.classList.add("mc-filter-dropdown--expanded");
    var inp=dd.querySelector(".mc-filter-dropdown__search-input");
    if(inp) inp.focus();
  }

  /* ── Lazy-Load: Modelle aus JSON rendern ── */
  function lazyLoadModels(dd){
    if(dd._lazyLoaded) return;
    var script=dd.querySelector(".mc-lazy-models-data");
    if(!script) return;
    var models;
    try{ models=JSON.parse(script.textContent); }catch(e){ return; }
    if(!models||!models.length) return;
    var list=dd.querySelector(".mc-filter-dropdown__list");
    if(!list) return;
    var existingLink=list.querySelector(".mc-filter-dropdown__link[data-param]");
    var param=existingLink?existingLink.getAttribute("data-param"):"filter.p.m.custom.modell";
    var url=new URL(window.location.href);
    var activeVals=url.searchParams.getAll(param);
    if(!activeVals.length) activeVals=url.searchParams.getAll("filter.p.m.custom.modell");
    var existingLabels={};
    list.querySelectorAll(".mc-filter-dropdown__item").forEach(function(li){
      existingLabels[li.getAttribute("data-label")||""]=true;
    });
    var frag=document.createDocumentFragment();
    for(var i=0;i<models.length;i++){
      var m=models[i];
      if(!m) continue;
      var mLower=m.toLowerCase();
      if(existingLabels[mLower]) continue;
      var isActive=activeVals.indexOf(m)!==-1;
      var li=document.createElement("li");
      li.className="mc-filter-dropdown__item";
      li.setAttribute("data-label",mLower);
      var a=document.createElement("a");
      a.href="#";
      a.className="mc-filter-dropdown__link"+(isActive?" mc-filter-dropdown__link--active":"");
      a.setAttribute("data-param",param);
      a.setAttribute("data-value",m);
      a.innerHTML='<span class="mc-filter-dropdown__check">'+(isActive?CHECK_SVG:"")+'</span><span class="mc-filter-dropdown__label">'+m.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")+'</span>';
      a.addEventListener("click",handleFilterClick);
      a._zfBound=true;
      li.appendChild(a);
      frag.appendChild(li);
    }
    list.appendChild(frag);
    script.remove();
    dd._lazyLoaded=true;
  }

  /* ── Pending selections tracking ── */
  var pendingSelections={};

  function getPendingUrl(dd){
    var paramName=dd.getAttribute("data-dropdown");
    if(!paramName) return null;
    var url=new URL(window.location.href);
    var params=url.searchParams;
    params.delete("page");
    if(pendingSelections[paramName]){
      params.delete(paramName);
      pendingSelections[paramName].forEach(function(v){
        params.append(paramName,v);
      });
    }
    return url.toString();
  }

  function updateApplyButton(dd){
    var btn=dd.querySelector(".mc-filter-dropdown__mob-apply") || dd.querySelector(".mc-filter-dropdown__desktop-save");
    if(!btn) return;
    var paramName=dd.getAttribute("data-dropdown");
    var selected=pendingSelections[paramName]||[];
    var currentUrl=new URL(window.location.href);
    var currentVals=currentUrl.searchParams.getAll(paramName);
    var changed = selected.length !== currentVals.length || selected.some(function(v){ return currentVals.indexOf(v)===-1; });
    if(dd.querySelector(".mc-filter-dropdown__desktop-save")){
      dd.querySelector(".mc-filter-dropdown__desktop-save").disabled = !changed;
    }
  }

  /* ── iOS Safari Fix: Dropdown zu body relocaten ── */
  var _relocatedDD = null;
  var _originalParent = null;
  var _originalNext = null;

  function relocateToBody(dd){
    if(_relocatedDD) returnToParent();
    _originalParent = dd.parentNode;
    _originalNext = dd.nextSibling;
    document.body.appendChild(dd);
    _relocatedDD = dd;
  }

  function returnToParent(){
    if(!_relocatedDD || !_originalParent) return;
    if(_originalNext && _originalNext.parentNode === _originalParent){
      _originalParent.insertBefore(_relocatedDD, _originalNext);
    } else {
      _originalParent.appendChild(_relocatedDD);
    }
    _relocatedDD = null;
    _originalParent = null;
    _originalNext = null;
  }

  /* ── Mobile Fullscreen Panel: Header + Footer ── */
  function ensureMobileUI(dd, chip){
    if(dd._mobUI) return;
    var header=document.createElement("div");
    header.className="mc-filter-dropdown__mob-header";
    var closeBtn=document.createElement("button");
    closeBtn.className="mc-filter-dropdown__mob-close";
    closeBtn.setAttribute("type","button");
    closeBtn.setAttribute("aria-label","Schließen");
    closeBtn.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    closeBtn.addEventListener("click",function(e){e.stopPropagation();closeAll();});
    var title=document.createElement("span");
    title.className="mc-filter-dropdown__mob-title";
    var chipText=chip?chip.querySelector("span"):null;
    title.textContent=chipText?chipText.textContent.replace(/\s*\(\d+\)\s*/,""):"Filter";
    var resetBtn=document.createElement("button");
    resetBtn.className="mc-filter-dropdown__mob-reset";
    resetBtn.setAttribute("type","button");
    resetBtn.textContent="Zurücksetzen";
    resetBtn.addEventListener("click",function(e){
      e.stopPropagation();
      var paramName=dd.getAttribute("data-dropdown");
      if(paramName){
        var url=new URL(window.location.href);
        url.searchParams.delete(paramName);
        url.searchParams.delete("page");
        window.location.href=url.toString();
      }
    });
    header.appendChild(closeBtn);
    header.appendChild(title);
    header.appendChild(resetBtn);
    dd.insertBefore(header,dd.firstChild);
    if(!dd.querySelector(".mc-filter-dropdown__price")){
      var footer=document.createElement("div");
      footer.className="mc-filter-dropdown__mob-footer";
      var applyBtn=document.createElement("button");
      applyBtn.className="mc-filter-dropdown__mob-apply";
      applyBtn.setAttribute("type","button");
      applyBtn.textContent="Ergebnisse anzeigen";
      applyBtn.addEventListener("click",function(e){
        e.stopPropagation();
        var targetUrl=getPendingUrl(dd);
        if(targetUrl) window.location.href=targetUrl;
        else closeAll();
      });
      footer.appendChild(applyBtn);
      dd.appendChild(footer);
    }
    dd._mobUI=true;
  }

  /* ── Desktop Footer: Zurücksetzen + Speichern ── */
  function ensureDesktopFooter(dd){
    if(dd._deskFooter) return;
    if(dd.querySelector(".mc-filter-dropdown__price")) return;
    var oldFooter=dd.querySelector(".mc-filter-dropdown__footer");
    if(oldFooter) oldFooter.style.display="none";
    var footer=document.createElement("div");
    footer.className="mc-filter-dropdown__desktop-footer";
    var resetBtn=document.createElement("button");
    resetBtn.className="mc-filter-dropdown__desktop-reset";
    resetBtn.setAttribute("type","button");
    resetBtn.textContent="Zurücksetzen";
    resetBtn.addEventListener("click",function(e){
      e.stopPropagation();
      var paramName=dd.getAttribute("data-dropdown");
      if(paramName){
        var url=new URL(window.location.href);
        url.searchParams.delete(paramName);
        url.searchParams.delete("page");
        window.location.href=url.toString();
      }
    });
    var saveBtn=document.createElement("button");
    saveBtn.className="mc-filter-dropdown__desktop-save";
    saveBtn.setAttribute("type","button");
    saveBtn.textContent="Speichern";
    saveBtn.addEventListener("click",function(e){
      e.stopPropagation();
      var targetUrl=getPendingUrl(dd);
      if(targetUrl) window.location.href=targetUrl;
      else closeAll();
    });
    footer.appendChild(resetBtn);
    footer.appendChild(saveBtn);
    dd.appendChild(footer);
    dd._deskFooter=true;
  }

  function initPendingFromCurrent(dd){
    var paramName=dd.getAttribute("data-dropdown");
    if(!paramName) return;
    var url=new URL(window.location.href);
    pendingSelections[paramName]=url.searchParams.getAll(paramName);
  }

  function handleChipClick(e){
    e.preventDefault();e.stopPropagation();
    var chip=e.currentTarget;
    var wrapper=chip.closest(".mc-filter-bar__wrapper");
    var dd=wrapper?wrapper.querySelector(DROPDOWN_SEL):null;
    /* If dropdown was relocated to body, find it there */
    if(!dd && _relocatedDD && wrapper){
      var ddParam=wrapper.querySelector(CHIP_SEL);
      if(ddParam){
        var filterName=ddParam.getAttribute("data-filter");
        if(filterName && _relocatedDD.getAttribute("data-dropdown")===filterName){
          dd=_relocatedDD;
        }
      }
    }
    if(!dd) return;
    var wasOpen=!dd.hidden;
    closeAll();
    if(!wasOpen){
      initPendingFromCurrent(dd);
      if(isMobile()){
        ensureMobileUI(dd, chip);
        /* iOS Safari fix: relocate dropdown to body to escape overflow:auto stacking context */
        relocateToBody(dd);
        if(dd.hasAttribute("data-lazy-models")){
          lazyLoadModels(dd);
          var search=dd.querySelector(".mc-filter-dropdown__search--hidden");
          if(search) search.classList.remove("mc-filter-dropdown__search--hidden");
          var showAllBtn=dd.querySelector(".mc-filter-dropdown__show-all");
          if(showAllBtn) showAllBtn.style.display="none";
          dd.classList.add("mc-filter-dropdown--expanded");
        }
      } else {
        ensureDesktopFooter(dd);
      }
      dd.hidden=false;dd.classList.add(OPEN_CLASS);
      if(isMobile()) document.body.style.overflow="hidden";
      /* Don't auto-focus search on mobile – triggers keyboard and distorts layout */
      if(!isMobile()){
        var inp=dd.querySelector(".mc-filter-dropdown__search-input");
        if(inp && !dd.querySelector(".mc-filter-dropdown__search--hidden")) inp.focus();
      }
      setTimeout(function(){document.addEventListener("click",outsideClick);},0);
    }
  }

  function outsideClick(e){
    if(isMobile()) return;
    if(!e.target.closest(".mc-filter-bar__wrapper")){closeAll();}
  }

  function closeAll(){
    document.removeEventListener("click",outsideClick);
    /* Return relocated dropdown to its original parent */
    returnToParent();
    document.querySelectorAll(DROPDOWN_SEL).forEach(function(dd){
      dd.hidden=true;dd.classList.remove(OPEN_CLASS);
    });
    document.body.style.overflow="";
  }

  function handleSearch(e){
    var q=e.target.value.toLowerCase().trim();
    var list=e.target.closest(DROPDOWN_SEL).querySelector(".mc-filter-dropdown__list");
    if(!list) return;
    if(!q){
      list.querySelectorAll(".mc-filter-dropdown__item").forEach(function(li){
        li.style.display="";
      });
      return;
    }
    var tokens=q.split(/\s+/);
    list.querySelectorAll(".mc-filter-dropdown__item").forEach(function(li){
      var label=li.getAttribute("data-label")||"";
      var match=true;
      for(var i=0;i<tokens.length;i++){
        if(label.indexOf(tokens[i])===-1){match=false;break;}
      }
      li.style.display=match?"":"none";
    });
  }

  /* ── Filter Click: Always multi-select (desktop + mobile) ── */
  function handleFilterClick(e){
    e.preventDefault();
    e.stopPropagation();
    var link=e.currentTarget;
    var param=link.getAttribute("data-param");
    var value=link.getAttribute("data-value");
    if(!param||!value) return;

    if(!pendingSelections[param]) pendingSelections[param]=[];
    var idx=pendingSelections[param].indexOf(value);
    if(idx!==-1){
      pendingSelections[param].splice(idx,1);
      link.classList.remove("mc-filter-dropdown__link--active");
      var check=link.querySelector(".mc-filter-dropdown__check");
      if(check) check.innerHTML="";
    } else {
      pendingSelections[param].push(value);
      link.classList.add("mc-filter-dropdown__link--active");
      var check2=link.querySelector(".mc-filter-dropdown__check");
      if(check2) check2.innerHTML=CHECK_SVG;
    }
    var dd=link.closest(DROPDOWN_SEL);
    if(dd) updateApplyButton(dd);
  }

  function handlePriceApply(e){
    e.preventDefault();
    var dd=e.target.closest(DROPDOWN_SEL);
    if(!dd) return;
    var inputs=dd.querySelectorAll(".mc-filter-dropdown__price-input");
    var url=new URL(window.location.href);
    var params=url.searchParams;
    params.delete("page");
    inputs.forEach(function(inp){
      var name=inp.getAttribute("name");
      if(!name) return;
      params.delete(name);
      if(inp.value) params.set(name,inp.value);
    });
    window.location.href=url.toString();
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",init);
  } else {
    init();
  }
})();
